import React, { FC, useState, useEffect, useContext } from 'react'
import platform from 'platform'
import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import {
  getUserData,
  getTrainingDays,
  unSubscribeNewsletter,
  subscribeToNewsletter,
} from '../../../../Api/backendApi'

import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'

interface ContactInterface {
  closeModal: Function
}

const Contact: FC<ContactInterface> = ({ closeModal }) => {
  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'} margin={'1% 0'}>
          Dane kontaktowe
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          fSize={'1.3rem'}
          width={isMobile ? '90%' : '60%'}
          margin={'1% 0'}
        >
          Fit Matka Wariatka sp. z o.o.
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          fSize={'1.3rem'}
          width={isMobile ? '90%' : '60%'}
          margin={'1% 0'}
        >
          ul. Ziemowita 7 lok. 2
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          fSize={'1.3rem'}
          width={isMobile ? '90%' : '60%'}
          margin={'1% 0'}
        >
          43-200 Pszczyna
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          fSize={'1.3rem'}
          width={isMobile ? '90%' : '60%'}
          margin={'1% 0'}
        >
          <a href="mailto:miazga@fitmatkawariatka.pl">
            miazga@fitmatkawariatka.pl
          </a>
        </GenericTextSpan>
      </GenericRow>
    </SingleSettingModalBox>
  )
}

export default Contact
